<div class="change-pwd-container" fxLayout="row" fxLayoutAlign="center">
    <div fxFlex="40" fxFlex.lt-md="100">
        <lib-ch-pwd (pwdChanged)="onPwdChanged()"
                    (loggedInProfile)="onLogin($event)"
                    (errorMsg)="onErrorOccurred($event)">
        </lib-ch-pwd>
    </div>
</div>
